import SeriesTitle from '../models/SeriesTitle';
import * as catalogUtility from "../lib/CatalogLinkUtilities";
import * as UrlUtilities from '../lib/UrlUtilities';
import * as utility from "../lib/AuthorUtility";
import * as linkUtility from "../lib/LinksUtilities";

export function getBooksInSeries(store) {
    let retval = [];

	let seriesInfo = store.FeatureContent.SeriesInfo;

	if (seriesInfo) {
		const titles = seriesInfo.series_titles;

        if (titles && titles.length > 0) {
            retval = titles.map((title) => {
				return new SeriesTitle(Object.assign({}, title, {
					author: '',
					ui: title.ui
				}));
            });
        }
    }
    return retval;
}

export function getNovumTitlesInSeries(store) {
    let retval = [];

	let seriesInfo = store && store.FeatureContent ? store.FeatureContent.SeriesInfo : undefined;

	if (seriesInfo) {
		const titles = seriesInfo.series_titles;

        if (titles && titles.length > 0) {          
            retval = titles.map((title) => {
                return {
                    ui: title.ui,
                    mainTitle: title.main_title,
                    author: utility.formatAuthorName(title.author),
                    bookjacketUrl: UrlUtilities.useLocalProtocol(title.bookjacket_url),
                    catalogLinkUrl: title.is_held_locally === false ? null : catalogUtility.getTitleCatalogLink(title.links),
                    description: title.description,
                    isHeld: title.is_held_locally,
                    availability: undefined,
                    novelistLinkUrl: linkUtility.getLinkToNoveListFromLinks(title.links) 
                };
            });
        }
    }
    return retval;
}



// WEBPACK FOOTER //
// ./src/data/BooksInSeriesSelectors.js